<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
         <div class="row  align-items-center form-header">
            <div class="col mt-4 d-none d-sm-block">
              <h4 class="ms-md-2 ml-lg-4">Edit Salary User Details</h4>
            </div>
            <div class="col mt-4 d-block d-sm-none">
                <h5>Edit Salary User</h5>
              </div>
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end ">
              <llp-button
                classNames="btn-secondary new-btn d-none d-sm-block"
                @click="BackToServices()"
              >
                 Back To Salary Payments
              </llp-button>
               <llp-button
                classNames="btn-secondary new-btn d-block d-sm-none add-btn"
                 @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>
            
              <!-- Check if selectedLandlord is available before rendering the data -->
              <div class="col-lg-8 col-md-12 col-sm-12  m-md-2 mt-md-4">
                <div class="card p-4">
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="nameLabel">Name:</llp-label>
                      <llp-input
                        id="nameId"
                        class="w-100"
                        autocomplete="off"
                        v-model="name"
                        :errors="validator.name.$errors"
                      ></llp-input>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="mobileLabel" :aria-label="Mobile"
                        >Mobile:</llp-label
                      >
                      <llp-input
                        id="mobileInput"
                        v-model="mobile"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.mobile.$errors"
                      ></llp-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="panId" :aria-label="name"
                        >Pan Number:</llp-label
                      >
                      <llp-input
                        id="PanInput"
                        v-model="pan"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.pan.$errors"
                      ></llp-input>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="AddressId" :aria-label="Lastname"
                        >Address:</llp-label
                      >
                      <llp-input
                        id="AddressInput"
                        v-model="address"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.accountNumber.$errors"
                      ></llp-input>
                    </div>
                  </div>
                    <div class="row">
                    <!-- Show the IFSC code dropdown only if a BankBranch is selected -->
                     <div   class="mb-2">
                        <a :href="offerLatter" target="_blank" class="text-primary">
                          View Current Attachment
                        </a>
                  </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="pincodeLabel" :aria-label="name"
                        >Joining Letter(optional):</llp-label
                      >
                      
                      <input
                        type="file"
                        id="InvoiceInput"
                        @change="handleOfferLatterFileUpload"
                        class="form-control w-100"
                      />
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="panId" :aria-label="name"
                        >Salary:</llp-label
                      >
                      <llp-input
                        id="SalaryInput"
                        v-model="salary"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.salary.$errors"
                      ></llp-input>
                    </div>
                  </div>
                   <h5 class="mt-2 fw-bold bank-details">Bank Details</h5>
                   <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
                    <div class="card mb-4">
                      <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="accountNumber" :aria-label="AccountNumber"
                        >Account Number:</llp-label
                      >
                      <llp-input
                        id="MonthlyRentInput"
                        v-model="accountNumber"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.accountNumber.$errors"
                      ></llp-input>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="pincodeLabel" :aria-label="name"
                        >Account Holder Name:</llp-label
                      >
                      <llp-input
                        id="accountName"
                        class="w-100"
                        autocomplete="off"
                        v-model="accountHolderName"
                        :errors="validator.accountHolderName.$errors"
                      ></llp-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="BankName" :aria-label="Firstname"
                        >Bank Name:</llp-label
                      >
                      <Dropdown
                        id="BankNameId"
                        v-model="bankName"
                        :options="bankData"
                        optionLabel="bank_name"
                        placeholder="Select your bank name"
                        class="form-control select-dropdown bbps-service-dropdown mobile-optimized-dropdown"
                        @change="onBankSelect"
                        filter
                        filterBy="bank_name"
                      >
                        <!-- How selected value is displayed in the input -->
                        <template #value="slotProps">
                          <div
                            v-if="slotProps.value"
                            class="flex align-items-center"
                          >
                            <div class="bank-options text-truncate">
                              {{ slotProps.value.bank_name }}
                            </div>
                          </div>
                          <span v-else>Select your bank name</span>
                        </template>

                        <!-- How each option is rendered in the dropdown -->
                        <template #option="slotProps">
                          <div class="flex align-items-center">
                            <div class="dropdown-option-text">
                              {{ slotProps.option.bank_name }}
                            </div>
                          </div>
                        </template>
                      </Dropdown>
                      <div v-if="validator.bankName.$error" class="text-danger">
                        <p>{{ validator.bankName.$errors[0].$message }}</p>
                      </div>
                    </div>
                    <!-- Show the Bank Branch dropdown only if a bank is selected -->
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="IFSCCodeLabel" :aria-label="ifscCode"
                        >IFSC Code:</llp-label
                      >
                      <llp-input
                        id="ifscCodeInput"
                        v-model="ifscCode"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.ifscCode.$errors"
                        placeholder="Enter IFSC code"
                      />
                    </div>
                  </div>
                 <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="branch" :aria-label="Branch"
                        >Branch:</llp-label
                      >
                      <llp-input
                        id="branch"
                        v-model="branch"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.branch.$errors"
                      ></llp-input>
                    </div>
                  </div>
                      </div>
                    </div>
</div>
                  <div class="row">
                    <div class="col-lg-2 col-sm-6 col-md-4">
                      <llp-button
                        :load-spinner="showaddadminSpinner"
                        classNames="btn-secondary new-btn"
                        @click="updateDonationPayment"
                      >
                        Update
                      </llp-button>
                    </div>
                  </div>
                </div>
              </div>
            
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { helpers, required, numeric, maxLength } from "@vuelidate/validators";
import ErrorService from "../../../services/error.service";
import { useVuelidate } from "@vuelidate/core";
import NetworkService from "@/services/network.service";
import Dropdown from "primevue/dropdown";

export default {
  setup: () => ({ validator: useVuelidate() }),
  components: {
    Dropdown,
  },
  data() {
    return {
      name: "",
      mobile: "",
      pan: "",
      address: "",
      accountNumber: "",
      bankName: null,
      branch: "",
      accountHolderName: "",
      ifscCode: "",
      salary: "",
      offerLatter: null,
      offerLatterError: "",
      availableIfscCodes: {},
      bankData: [],
      itemId: this.$route.params.id,
      serviceId: this.$route.params.serviceId,
      userId: localStorage.getItem("User_id"),
      showaddadminSpinner: false,
      userDetails:[]
    };
  },
  validations() {
    return {
      name: { required: helpers.withMessage("Name is required.", required),
         alphaOnly: helpers.withMessage(
          "Name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
       },
      mobile: {
        required: helpers.withMessage("Mobile number is required.", required),
        numeric: helpers.withMessage("Mobile number must be numeric.", numeric),
        maxLength: helpers.withMessage(
          "Mobile number must be 10 digits.",
          maxLength(10)
        ),
        validMobile: helpers.withMessage(
          "Mobile number must start with 6, 7, 8, or 9.",
          (value) => (value ? /^[6789]\d{9}$/.test(value) : true)
        ),
      },
      pan: {
        required: helpers.withMessage("Pan number is required.", required),
          validPAN: helpers.withMessage(
          "PAN must be in format(e.g. ABCDE1234F)",
          (value) =>
            value ? /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value.toUpperCase()) : true
        ),
      },
 branch: {
        required: helpers.withMessage("Branch is required.", required),
        alphaOnly: helpers.withMessage(
          "Branch should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      bankName: {
        required: helpers.withMessage("Bank name is required.", required),
      },
      accountNumber: {
        required: helpers.withMessage("Account number is required.", required),
         numericOnly: helpers.withMessage(
          "Account number should contain only numbers.",
          (value) => /^\d+$/.test(value)
        ),
      },
      accountHolderName: {
        required: helpers.withMessage(
          "Account holder name is required.",
          required
        ),
        alphaOnly: helpers.withMessage(
          "Account holder name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      ifscCode: {
        required: helpers.withMessage("IFSC code is required.", required),
        alphanumeric: helpers.withMessage(
          "IFSC code should contain only characters and numbers.",
          (value) => /^[A-Za-z0-9]+$/.test(value)
        ),
      },
      salary: {
        required: helpers.withMessage("Salary is required.", required),
          numericOnly: helpers.withMessage(
          "Salary must be a valid number.",
          (value) => /^(\d+(\.\d{1,2})?)$/.test(value)
        ),
      },
    };
  },
  mounted() {
    this.fetchBankDetail();
    this.fetchingSalaryDetails();
  },

  methods: {
    BackToServices() {
      this.$router.back();
    },
    handleOfferLatterFileUpload(event) {
      const file = event.target.files[0];
      const allowedTypes = ["application/pdf"];
      if (file) {
        if (!allowedTypes.includes(file.type)) {
          this.offerLatterError = "PDF file only allowed.";
          this.offerLatter = null;
        } else {
          this.offerLatterError = "";
          this.offerLatter = file;
        }
      }
    },
    async fetchBankDetail() {
      try {
        const responseData = await NetworkService.get("bank-list");
        this.bankData = responseData;
      } catch (error) {
        this.$refs.toast.show("Unable to fetching bank details", "error");
      }
    },

  onBankSelect() {
      const selectedBank = this.bankName;
      if (selectedBank) {
        if (Array.isArray(selectedBank.ifsc_codes)) {
          this.availableIfscCodes = selectedBank.ifsc_codes;
        } else if (selectedBank.ifsc_code) {
          this.availableIfscCodes = [selectedBank.ifsc_code];
        } else {
          this.availableIfscCodes = [];
        }
        this.ifscCode = this.availableIfscCodes[0] || "";
      } else {
        this.availableIfscCodes = [];
        this.ifscCode = "";
      }
    },
    async fetchingSalaryDetails() {
      try {
         if (this.bankData.length === 0) {
          await this.fetchBankDetail();
        }
        const caRelatedResponse = await NetworkService.get(
          `/get-service-list-edit/${this.itemId}/${this.userId}/${this.serviceId}`
        );
        this.userDetails = caRelatedResponse.details;
        this.name = this.userDetails.name;
        this.mobile = this.userDetails.mobile;
        this.pan = this.userDetails.pan_number;
        this.address = this.userDetails.address;
        this.salary = this.userDetails.salary;
        this.offerLatter = this.userDetails.document_url; 
        this.accountHolderName = this.userDetails.account_holder_name;
        this.accountNumber = this.userDetails.account_number;
        this.bankName = this.userDetails.bank_name;
        this.ifscCode = this.userDetails.ifsc_code;
        this.branch = this.userDetails.bank_branch;
         const selectedBank = this.bankData.find(
          (bank) => bank.bank_name === this.userDetails.bank_name
        );
        this.bankName = selectedBank || null;
        if (selectedBank) {
          if (Array.isArray(selectedBank.ifsc_codes)) {
            this.availableIfscCodes = selectedBank.ifsc_codes;
          } else if (selectedBank.ifsc_code) {
            this.availableIfscCodes = [selectedBank.ifsc_code];
          } else {
            this.availableIfscCodes = [];
          }
        }
      } catch (error) {
      if(error.message)
      {
          this.$refs.toast.show(error.message,"error")
      }else{
          this.$refs.toast.show(
          "Unable to fetch salary payment details",
          "error"
        );
      }
      }
    },

    async updateDonationPayment() {
      this.validator
        .$validate()
        .then(async (isValid) => {
          if (!isValid) return Promise.reject();
          // if (!this.agreement) {
          //   this.$refs.toast.show("Please upload a valid document.", "error");
          //   return;
          // }
          this.showaddadminSpinner = true;
          const formData = new FormData();
          formData.append("service_id", this.serviceId);
          formData.append("user_id", this.userId);
          formData.append("name", this.name);
          formData.append("mobile", this.mobile);
          formData.append("pan_number", this.pan);
          formData.append("address", this.address);
          formData.append("salary", this.salary);
          formData.append("account_number", this.accountNumber);
          formData.append("document", this.agreement);
          formData.append("account_holder_name", this.accountHolderName),
          formData.append("bank_name", this.bankName?.bank_name || ""),
            formData.append("ifsc_code", this.ifscCode);
            formData.append("bank_branch",this.branch)
          try {
            const res = await NetworkService.post(
              `/update-services/${this.itemId}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            this.$refs.toast.show(res.data.message);
            this.showaddadminSpinner = false;
            setTimeout(() => {
              this.$router.back();
            }, 3000);
          } catch (error) {
            this.showaddadminSpinner = false;
            this.$refs.toast.show(
              "Unable to upadte the salary Payment details",
              "error"
            );
          }
        })
        .catch((error) => {
            this.showaddadminSpinner = false;

          if (error) {
            this.$refs.toast.show(
              "Unable to update the salary Payment details.",
              "error"
            );
          } else {
            this.$refs.toast.show(
              ErrorService.getErrorMessages(error),
              "error"
            );
          }
        });
    },
  },
};
</script>

